<template>
  <div>
    <Form />
  </div>
</template>

<script>
import Form from "./Form.vue";

export default {
  name: "PageValentine",
  data() {
    return {};
  },
  components: {
    Form,
  },

  inject: ["loader"],

  created() {},
};
</script>
